import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/**
 * Offset the arrow buttons so their centers align with the vertical center
 * of the quote element in the active slide.
 */
function positionArrows(el) {
  const row = el.querySelector(".testimonial-slider__row");
  const prevArrow = el.querySelector(".testimonial-slider__arrow--prev");
  const nextArrow = el.querySelector(".testimonial-slider__arrow--next");
  const swiperWrap = el.querySelector(".testimonial-slider__swiper-wrap");
  const quote = el.querySelector(
    ".swiper-slide-active .testimonial-slider__quote, .swiper-slide .testimonial-slider__quote",
  );

  if (!prevArrow || !nextArrow || !swiperWrap || !quote || !row) return;

  const swiperWrapTop = swiperWrap.getBoundingClientRect().top;
  const quoteRect = quote.getBoundingClientRect();

  // Center of the quote relative to the top of the swiper-wrap column
  const quoteMidOffset = quoteRect.top - swiperWrapTop + quoteRect.height / 2;

  const arrowHeight = prevArrow.offsetHeight;
  const marginTop = Math.max(0, quoteMidOffset - arrowHeight / 2);

  prevArrow.style.marginTop = marginTop + "px";
  nextArrow.style.marginTop = marginTop + "px";
}

document.querySelectorAll("[data-testimonial-slider]").forEach(function (el) {
  const swiperEl = el.querySelector(".testimonial-slider__swiper");
  if (!swiperEl) return;

  const slides = swiperEl.querySelectorAll(".swiper-slide");
  if (slides.length <= 1) return;

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation, Pagination],
    loop: true,
    navigation: {
      prevEl: el.querySelector(".testimonial-slider__arrow--prev"),
      nextEl: el.querySelector(".testimonial-slider__arrow--next"),
    },
    pagination: {
      el: el.querySelector(".testimonial-slider__pagination"),
      clickable: true,
    },
    on: {
      afterInit: function () {
        positionArrows(el);
      },
    },
  });

  // Re-position on resize in case the quote height changes
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      positionArrows(el);
    }, 100);
  });
});
